import { forwardRef } from 'react';
import { Button } from '@chakra-ui/react';

const SKButton = forwardRef((props, ref) => {
  return (
    <Button
      ref={ref}
      colorScheme={'brand'}
      color="white"
      bgGradient="linear(to-r, #BE6F4F, #FAA381)"
      fontWeight={'normal'}
      {...props}
    >
      {props.children}
    </Button>
  );
});

export default SKButton;
